<template>
  <v-hover v-slot:default="{ hover }" close-delay="300" open-delay="100" v-if="!editing">
    <v-subheader class="text-body-1">
      {{textVal}}
      <v-slide-x-transition>
        <v-btn text color="primary" class="ml-2" v-show="hover" small @click.stop="editing = true">
          <v-icon small>mdi-pencil</v-icon>
          修改
        </v-btn>
      </v-slide-x-transition>
    </v-subheader>
  </v-hover>
  <v-form class="px-4" v-else>
    <v-text-field :counter="counter" v-model="editVal" single-line dense outlined></v-text-field>
    <v-btn class="mr-2" color="primary" elevation="0" @click.stop="save(editVal)">保存</v-btn>
    <v-btn class="ml-2" color="grey" outlined @click.stop="editing = false">取消</v-btn>
  </v-form>
</template>

<script>
export default {
  name: 'TextEditor',
  props: {
    textVal: {
      type: String,
      default: ''
    },
    textKey: {
      type: String,
      default: ''
    },
    counter: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      editing: false,
      editVal: ''
    }
  },
  watch: {
    editing (newVal) {
      if (newVal === true) {
        this.editVal = this.textVal
      }
    }
  },
  methods: {
    save (value) {
      if (this.textVal !== value) {
        this.$emit('change', {
          key: this.textKey,
          value: value
        })
      }
      this.editing = false
    }
  }
}
</script>
